import { STATUS_TYPE } from '../../../enum';

export interface FindPromoCode {
  limit?: number;
  skip?: number;
  search?: string;
}

export interface GetPromoCode {
  id: string;
}

export interface CreatePatchPromoCode {
  id?: string;
  code: string;
  discountType: string;
  discountAmount: string;
  startDate: Date;
  endDate: Date;
  usageLimit: string;
  usageLimitPerUser: string;
  minimumPurchaseAmount: string;
  maximumDiscountAmount: string;
  // appliesTo: string;
  activeState: boolean;
}

export interface PromoCode {
  id: string;
  code: string;
  discountType: string;
  discountAmount: string;
  startDate: Date;
  endDate: Date;
  usageLimit: string;
  usageLimitPerUser: string;
  minimumPurchaseAmount: string;
  maximumDiscountAmount: string;
  // appliesTo: string;
  activeState: boolean;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  updatedBy: string;
}

export interface InitialState {
  data: PromoCode[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
